module.exports = __webpack_public_path__ + "static/employees-scheduling-43f058739d13dd083caaa84752dd27b3.png";